import isSchoolBrandBlockedToChangeRoles from './isSchoolBrandBlockedToChangeRoles'
import isUserExternalReferenceBlockedToChangeRoles from './isUserExternalReferenceBlockedToChangeRoles'

const canChangeSchoolRoles = ({
  byIntegration,
  schoolBrands,
  userExternalReference,
  isUserByIntegration,
}) => {
  const isSchoolBrandBlockedToChangeRole = isSchoolBrandBlockedToChangeRoles(schoolBrands)

  const isUserExternalReferenceBlockedToChangeRole =
    isUserExternalReferenceBlockedToChangeRoles(userExternalReference)

  if (
    byIntegration &&
    isSchoolBrandBlockedToChangeRole &&
    isUserExternalReferenceBlockedToChangeRole
  ) {
    return false
  }

  if (byIntegration && isSchoolBrandBlockedToChangeRole) {
    return true
  }

  if (!isUserByIntegration && !isUserExternalReferenceBlockedToChangeRole) {
    return true
  }

  return !byIntegration
}

export default canChangeSchoolRoles
